// Dark/light theme. The class lives on <html>; the initial value is set by an inline script in
// public/index.html BEFORE first paint (zero flash), so here we only read the current state and flip
// it. `theme-anim` on <html> enables a brief colour cross-fade during the switch, then is removed so
// it never taxes normal interaction.
const KEY = "stride_theme";

export function currentTheme() {
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}

export function toggleTheme() {
  const root = document.documentElement;
  const next = root.classList.contains("dark") ? "light" : "dark";
  root.classList.add("theme-anim");
  root.classList.toggle("dark", next === "dark");
  try { localStorage.setItem(KEY, next); } catch {}
  window.setTimeout(() => root.classList.remove("theme-anim"), 420);
  return next;
}
